import { useMemo } from "react";
import type { AdRow } from "@/types/bulkAd";

export interface PreviewData {
  adName: string;
  primaryText: string;
  headline: string;
  description: string;
  displayLink: string;
  ctaType: string;
  facebookPageId: string;
  facebookPageName: string;
  instagramActorId: string;
  creativeSquareName: string;
  creativeSquareThumbnailUrl: string;
  creativeVerticalName: string;
  creativeVerticalThumbnailUrl: string;
  adFormat: string;
  destinationUrl: string;
  flexibleFirstAssetThumbnail: string;
  carouselCards: Array<{
    thumbnailUrl: string;
    headline: string;
    description: string;
  }>;
}

export function useSelectedRowPreview(
  rows: AdRow[],
  selectedRowIndex: number | null
): PreviewData | null {
  return useMemo(() => {
    if (selectedRowIndex === null || !rows[selectedRowIndex]) return null;

    const row = rows[selectedRowIndex];

    return {
      adName: row.adName || "",
      primaryText: row.primaryTexts?.[0] || "",
      headline: row.headlines?.[0] || "",
      description: row.descriptions?.[0] || "",
      displayLink: row.displayLink || "",
      ctaType: row.ctaType || "LEARN_MORE",
      facebookPageId: row.facebookPage?.id || "",
      facebookPageName: row.facebookPage?.name || "",
      instagramActorId: row.instagramAccount?.id || "",
      creativeSquareName: row.creatives?.feed?.filename || "",
      creativeSquareThumbnailUrl: row.creatives?.feed?.thumbnail || "",
      creativeVerticalName: row.creatives?.vertical?.filename || "",
      creativeVerticalThumbnailUrl: row.creatives?.vertical?.thumbnail || "",
      adFormat: row.adFormat || "Single Image or Video",
      destinationUrl: row.url || "",
      flexibleFirstAssetThumbnail: row.flexibleData?.assets?.[0]?.thumbnail_url || "",
      carouselCards: (row.carouselData?.cards || []).map((card: any) => ({
        thumbnailUrl: card.thumbnail_url || "",
        headline: card.headline || "",
        description: card.description || "",
      })),
    };
  }, [rows, selectedRowIndex]);
}
